
import Header from "./components/layout/Header.vue";
import HeaderDesktop from "./components/layout/HeaderDesktop.vue";
import Footer from "./components/layout/Footer.vue";
import CompleteRegisterCard from "./components/register/CompleteRegisterCard.vue";
import BottomNavigation from "./components/layout/BottomNavigation.vue";
import Drawer from "./components/layout/Drawer.vue";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import useBreakpoints from "@/services/Breakpoints";
import { useRoute } from "vue-router";

export default {
  async setup() {
    //:: INIT
    const store = useStore();
    const route = useRoute();
    onMounted(() => {
      if (route.name === "Home") isHomeView.value = true;
      else isHomeView.value = false;
    });
    watch(route, () => {
      if (route.name === "Home") isHomeView.value = true;
      else isHomeView.value = false;
    });
    const { type } = useBreakpoints();

    //:: Get event info
    const eventData = computed(() => store.getters["user/eventData"]);
    const eventID = route.params.eventID;
    await store.dispatch("user/getEventDataExists", eventID);
    const activateCardRegister = computed(
      () => store.getters["user/activateCardRegister"]
    );

    //:: APP setup
    const isHomeView = ref(false);
    const getValidEvent = computed(() => store.getters["user/getValidEvent"]);
    const isLogged = computed(() => store.getters["user/isLogged"]);
    store.dispatch("user/setLenguage");
    setEventColors();

    function setEventColors() {
      if (eventData.value.themeSettings) {
        document.documentElement.style.setProperty(
          "--theme-primary-color",
          `${eventData.value.themeSettings.primaryColor}`
        );
        document.documentElement.style.setProperty(
          "--theme-primary-text-color",
          `${eventData.value.themeSettings.primaryTextColor}`
        );
        document.documentElement.style.setProperty(
          "--theme-primary-dark-color",
          `${eventData.value.themeSettings.primaryColorDark}`
        );
        document.documentElement.style.setProperty(
          "--theme-primary-dark-text-color",
          `${eventData.value.themeSettings.primaryTextColorDark}`
        );
        document.documentElement.style.setProperty(
          "--theme-primary-light-color",
          `${eventData.value.themeSettings.primaryColorLight}`
        );
        document.documentElement.style.setProperty(
          "--theme-primary-light-text-color",
          `${eventData.value.themeSettings.primaryTextColorLight}`
        );

        //Secondary color
        document.documentElement.style.setProperty(
          "--theme-secondary-color",
          `${eventData.value.themeSettings.secondaryColor}`
        );
        document.documentElement.style.setProperty(
          "--theme-secondary-text-color",
          `${eventData.value.themeSettings.secondaryTextColor}`
        );
        document.documentElement.style.setProperty(
          "--theme-secondary-dark-color",
          `${eventData.value.themeSettings.secondaryColorDark}`
        );
        document.documentElement.style.setProperty(
          "--theme-secondary-dark-text-color",
          `${eventData.value.themeSettings.secondaryTextColorDark}`
        );
        document.documentElement.style.setProperty(
          "--theme-secondary-light-color",
          `${eventData.value.themeSettings.secondaryColorLight}`
        );
        document.documentElement.style.setProperty(
          "--theme-secondary-light-text-color",
          `${eventData.value.themeSettings.secondaryTextColorLight}`
        );

        // Card colors
        document.documentElement.style.setProperty(
          "--card-color1",
          `${eventData.value.themeSettings.cardColor1}`
        );
        document.documentElement.style.setProperty(
          "--card-color2",
          `${eventData.value.themeSettings.cardColor2}`
        );
        document.documentElement.style.setProperty(
          "--card-color3",
          `${eventData.value.themeSettings.cardColor3}`
        );
        document.documentElement.style.setProperty(
          "--card-color4",
          `${eventData.value.themeSettings.cardColor4}`
        );

        //Text color
        document.documentElement.style.setProperty(
          "--black__base__color",
          `#212121`
        );
        document.documentElement.style.setProperty(
          "--gray__base__color",
          `#727272`
        );
      }
    }
    return {
      type,
      isHomeView,
      getValidEvent,
      eventData,
      isLogged,
      activateCardRegister,
    };
  },
  components: {
    AppFooter: Footer,
    AppDrawer: Drawer,
    AppHeader: Header,
    AppHeaderDesktop: HeaderDesktop,
    AppBottomNavigation: BottomNavigation,
    AppCompleteRegisterCard: CompleteRegisterCard,
  },
};
